import { Field, LinkField, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';

type C50TopStatisticsFields = {
  Headline?: Field<string>;
  SupportCopy?: RichTextField;
  SupportCopyBottom?: RichTextField;
  Cta?: LinkField;
};

type C50TopStatisticsParams = {
  HeadlineTag?: string;
  ContentAlignments?: string;
  CtaAlignment?: string;
  NumberOfColumns?: string;
  BackgroundColor?: string;
} & DynamicPlaceholderParams &
  AnchorTargetParams &
  TranslationOptionsParams;

export type C50TopStatisticsProps = RenderingProps<C50TopStatisticsFields, C50TopStatisticsParams>;
